import { i18nMark } from 'lingui-react';

const messages = {
  label: i18nMark('OPTIONS:'),
};

export default messages;



// WEBPACK FOOTER //
// ./components/_common/DropDownSelector/messages.js